// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606160556/js/" + chunkId + "." + {"44":"d5425d4b","225":"af1ac32e","481":"acf9710d","486":"78377cd7","770":"72f410dd"}[chunkId] + ".0.299904268803725.chunk.js";
};